import React from 'react'

import { FormikTextInput } from 'components/FormikFields'
import { FieldKit } from 'containers/FormBuilder'
import ConditionTab from 'containers/VehicleSelection/ConditionTab'
import { FormikValues } from 'formik'
import AssetSubtype from 'state/enums/AssetSubtype'

import { ComponentRow, ConditionTabWrapper } from '../MarineWriteIn.styled'
import { MARINE_CONDITION_ITEMS } from './marineConditionItems'
import YearDropdown from './YearDropdown'

interface Props {
    formik: FieldKit<FormikValues>
    prefilled?: boolean
}

export default function TrailerCollateralForm({
    formik,
    prefilled,
}: Readonly<Props>) {
    const {
        trailer: { condition, year, make },
    } = formik.values.marine

    return (
        <>
            <ConditionTabWrapper>
                <ConditionTab
                    name="marine.trailer.condition"
                    label="Trailer Condition"
                    items={MARINE_CONDITION_ITEMS}
                    prefilled={prefilled}
                />
            </ConditionTabWrapper>
            <ComponentRow gridTemplateColumns="125px 180px 1fr">
                <YearDropdown
                    formik={formik}
                    assetSubtype={AssetSubtype.TRAILER}
                    fieldName="marine.trailer.year"
                    selectedYear={year}
                    condition={condition}
                    label="Trailer Year"
                    prefilled={prefilled}
                />
                <FormikTextInput
                    name="marine.trailer.make"
                    label="Trailer Make"
                    disabled={!year}
                    prefilled={prefilled}
                />
                <FormikTextInput
                    name="marine.trailer.model"
                    label="Trailer Model"
                    disabled={!make}
                    prefilled={prefilled}
                />
            </ComponentRow>
        </>
    )
}
